import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "cancel-flow__screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "cancel-flow__eyebrow" }, "BEFORE YOU GO...", -1)
const _hoisted_3 = { class: "cancel-flow__main" }
const _hoisted_4 = { class: "cancel-flow__heading" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "cancel-flow__stat-rows" }
const _hoisted_7 = { class: "cancel-flow__stat-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "cancel-flow__stat-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#00766a",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
  ])
], -1)
const _hoisted_9 = { class: "cancel-flow__body" }
const _hoisted_10 = { class: "cancel-flow__stat-row" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<span class=\"cancel-flow__stat-icon\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#00766a\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"13\" r=\"8\"></circle><path d=\"M12 9v4l2 2\"></path><path d=\"M5 3 2 6\"></path><path d=\"m22 6-3-3\"></path></svg></span>", 1)
const _hoisted_12 = { class: "cancel-flow__body" }
const _hoisted_13 = {
  key: 0,
  class: "cancel-flow__stat-row"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<span class=\"cancel-flow__stat-icon\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#00766a\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"2\" y=\"3\" width=\"20\" height=\"14\" rx=\"2\"></rect><line x1=\"8\" y1=\"21\" x2=\"16\" y2=\"21\"></line><line x1=\"12\" y1=\"17\" x2=\"12\" y2=\"21\"></line></svg></span>", 1)
const _hoisted_15 = { class: "cancel-flow__body" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"cancel-flow__stat-row\"><span class=\"cancel-flow__stat-icon\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#00766a\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71\"></path><path d=\"M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71\"></path></svg></span><p class=\"cancel-flow__body\"><strong>Wireless content sharing</strong> keeps your team connected across every screen</p></div><div class=\"cancel-flow__stat-row\"><span class=\"cancel-flow__stat-icon\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#00766a\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"13\" r=\"8\"></circle><path d=\"M12 9v4l2 2\"></path></svg></span><p class=\"cancel-flow__body\"><strong>Hours saved</strong> every month versus cable-based or manual sharing</p></div><div class=\"cancel-flow__stat-row\"><span class=\"cancel-flow__stat-icon\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#00766a\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"2\" y=\"3\" width=\"20\" height=\"14\" rx=\"2\"></rect><line x1=\"8\" y1=\"21\" x2=\"16\" y2=\"21\"></line></svg></span><p class=\"cancel-flow__body\"><strong>Always-on signage</strong> that highlights what matters across your spaces</p></div>", 3)
const _hoisted_19 = { class: "cancel-flow__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, [
        (_ctx.statsAvailable)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("Before you cancel,"),
              _hoisted_5,
              _createTextVNode("did you know...")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Before you cancel, take a moment...")
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.statsAvailable)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("p", _hoisted_9, [
                  _createTextVNode("There were "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.stats.connectionCount) + " connections", 1),
                  _createTextVNode(" to your screens this past year")
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("p", _hoisted_12, [
                  _createTextVNode("People spent "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.stats.mirroringHours) + " hours", 1),
                  _createTextVNode(" sharing to your screens in the past year")
                ])
              ]),
              (_ctx.stats && _ctx.stats.signageCount != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("p", _hoisted_15, [
                      _createTextVNode("You have "),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.stats.signageCount) + " signage", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.stats.signageCount === 1 ? 'item' : 'items') + " ready for your screens", 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_16
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("button", {
        type: "button",
        class: "cancel-flow__btn cancel-flow__btn--primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('stay')))
      }, "I'll stay"),
      _createElementVNode("button", {
        type: "button",
        class: "cancel-flow__btn cancel-flow__btn--danger",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('next')))
      }, "Continue cancellation")
    ])
  ]))
}